import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'sonner';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

interface DeleteDocChronologyParameters {
  matterId: string;
  subsetId: string;
  docChronologyId: string;
}

interface HookProps {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
}

export const useDeleteDocChronology = ({ onSuccess, onError }: HookProps = {}) => {
  const { getFetchConfig } = useGetFetchConfig();
  const queryClient = useQueryClient();

  return useMutation(
    async ({ matterId, subsetId, docChronologyId }: DeleteDocChronologyParameters) => {
      const fetchConfig = getFetchConfig({
        method: FetchMethod.DELETE,
      });

      const res = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/doc-chronology/${docChronologyId}`,
        fetchConfig,
      );

      if (!res.ok) {
        throw new Error('Network response was not ok');
      }
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries([QueryEntity.DocChronologies, { subsetId: variables.subsetId }]);
        queryClient.invalidateQueries([QueryEntity.MatterDocChronologies, { matterId: variables.matterId }]);
        toast.success('Successfully deleted document chronology');

        onSuccess?.();
      },
      onError: (error: Error) => {
        toast.error('Failed to delete document chronology');
        onError?.(error);
      },
    },
  );
};
